import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressContactsAllocatorApiV4ContactSubmitServiceV4Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/contacts/v4/contact-submit',
        destPath: '/v4/contact-submit',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/contacts/v4/contact-submit',
        destPath: '/v4/contact-submit',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/contacts/v4/contact-submit',
        destPath: '/v4/contact-submit',
      },
    ],
    _: [
      {
        srcPath: '/_api/contacts/v4/contact-submit',
        destPath: '/v4/contact-submit',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/contacts/v4/contact-submit',
        destPath: '/v4/contact-submit',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_crm_submitted-contact';

/**
 * Appends an existing contact or creates a contact if it doesn't exist.
 *
 * For internal docs, see
 * [Submit Contacts](crm.contact-submit-service.introduction).
 */
export function submitContact(payload: object): RequestOptionsFactory<any> {
  function __submitContact({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'info.addresses.items.address.geocode.latitude' },
          { path: 'info.addresses.items.address.geocode.longitude' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'info.picture.image.urlExpirationDate' },
          { path: 'activity.activityDate' },
          { path: 'activity.date' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.contacts.v4.submit_contact',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.contacts.allocator.api.v4.ContactSubmitServiceV4.SubmitContact',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressContactsAllocatorApiV4ContactSubmitServiceV4Url({
        protoPath: '/v4/contact-submit',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __submitContact;
}
